import React from 'react';
import { useSEO } from '../hooks/useSEO';
import Navbar from './Navbar';
import Footer from './Footer';
import Container from './Container';

const AboutUsPage = () => {
  useSEO({
    title: 'Σχετικά με εμάς - TailClinic',
    description: 'Μάθετε για την αποστολή, το όραμα και την ομάδα πίσω από το TailClinic — το σύγχρονο λογισμικό διαχείρισης κτηνιατρείου.',
    canonical: 'https://www.tailclinic.gr/about',
  });

  const values = [
    {
      title: 'Ακεραιότητα',
      desc: 'Διατηρούμε τα υψηλότερα ηθικά πρότυπα και απόλυτη διαφάνεια στη διαχείριση των δεδομένων σας.',
      icon: <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
    },
    {
      title: 'Καινοτομία',
      desc: 'Δεν επαναπαυόμαστε. Συνεχώς αναζητούμε νέους, έξυπνους τρόπους να κάνουμε τη δουλειά σας ευκολότερη.',
      icon: <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 10V3L4 14h7v7l9-11h-7z" />
    },
    {
      title: 'Συνεργασία',
      desc: 'Ακούμε τους κτηνιάτρους. Κάθε νέο χαρακτηριστικό σχεδιάζεται με βάση το δικό σας feedback.',
      icon: <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
    },
    {
      title: 'Αριστεία',
      desc: 'Προσφέρουμε μια κορυφαία εμπειρία χρήσης, με ταχύτητα, αξιοπιστία και άμεση τεχνική υποστήριξη.',
      icon: <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z" />
    },
    {
      title: 'Κοινότητα',
      desc: 'Χτίζουμε ένα οικοσύστημα που σέβεται την ευημερία των ζώων και υποστηρίζει τον άνθρωπο που τα φροντίζει.',
      icon: <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9" />
    }
  ];

  return (
    <div style={{ backgroundColor: '#1A202C', minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <Navbar />
      
      <main style={{ padding: '6rem 0', position: 'relative', overflow: 'hidden', flex: 1 }}>
        <div style={{ position: 'absolute', inset: 0, background: 'radial-gradient(800px 800px at 10% -10%, rgba(16,185,129,0.12), transparent), radial-gradient(800px 800px at 110% 10%, rgba(59,130,246,0.06), transparent)' }} />
        
        <Container>
          {/* Header */}
          <div style={{ textAlign: 'center', marginBottom: '5rem', position: 'relative' }}>
            <div style={{
              display: 'inline-block',
              padding: '0.35rem 1rem',
              borderRadius: '9999px',
              fontSize: '0.85rem',
              fontWeight: 700,
              color: '#10B981',
              backgroundColor: 'rgba(16,185,129,0.1)',
              border: '1px solid rgba(16,185,129,0.2)',
              marginBottom: '1.5rem',
              textTransform: 'uppercase',
              letterSpacing: '0.05em'
            }}>
              Η ΟΜΑΔΑ ΜΑΣ
            </div>
            <h1 style={{
              fontSize: '3.5rem',
              fontWeight: '800',
              color: 'white',
              marginBottom: '1.25rem',
              lineHeight: '1.2',
              letterSpacing: '-0.02em'
            }}>
              Σχετικά με το <span style={{ color: '#10B981' }}>Tail</span>Clinic
            </h1>
            <p style={{
              fontSize: '1.2rem',
              color: '#9CA3AF',
              maxWidth: '650px',
              margin: '0 auto',
              lineHeight: '1.6'
            }}>
              Γνωρίστε την αποστολή, τις αξίες και τους ανθρώπους που εργάζονται καθημερινά για να κάνουν την κτηνιατρική πράξη πιο εύκολη.
            </p>
          </div>

          <div style={{ maxWidth: '1000px', margin: '0 auto', display: 'flex', flexDirection: 'column', gap: '5rem', position: 'relative' }}>
            
            {/* Mission & Vision (Side by Side) */}
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))', gap: '2rem' }}>
              <div style={{ backgroundColor: '#1F2937', padding: '2.5rem', borderRadius: '1.5rem', border: '1px solid #374151' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1.5rem' }}>
                  <div style={{ backgroundColor: 'rgba(16,185,129,0.1)', padding: '0.75rem', borderRadius: '0.75rem', color: '#10B981' }}>
                    <svg width="24" height="24" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"/></svg>
                  </div>
                  <h2 style={{ fontSize: '1.75rem', fontWeight: '700', color: 'white' }}>Η Αποστολή μας</h2>
                </div>
                <p style={{ fontSize: '1.05rem', color: '#D1D5DB', lineHeight: '1.7' }}>
                  Να ενδυναμώσουμε τις κτηνιατρικές κλινικές με καινοτόμες λύσεις λογισμικού που <strong>απλοποιούν τις λειτουργίες</strong>, μειώνουν τη γραφειοκρατία και επιτρέπουν στους κτηνιάτρους να αφιερώνουν τον χρόνο τους εκεί που πραγματικά μετράει: στη φροντίδα των ζώων.
                </p>
              </div>

              <div style={{ backgroundColor: '#1F2937', padding: '2.5rem', borderRadius: '1.5rem', border: '1px solid #374151' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1.5rem' }}>
                  <div style={{ backgroundColor: 'rgba(59,130,246,0.1)', padding: '0.75rem', borderRadius: '0.75rem', color: '#3B82F6' }}>
                    <svg width="24" height="24" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" /></svg>
                  </div>
                  <h2 style={{ fontSize: '1.75rem', fontWeight: '700', color: 'white' }}>Το Όραμά μας</h2>
                </div>
                <p style={{ fontSize: '1.05rem', color: '#D1D5DB', lineHeight: '1.7' }}>
                  Να γίνουμε ο πιο αξιόπιστος "ψηφιακός βοηθός" κάθε κτηνιατρείου στην Ελλάδα και το εξωτερικό, προσφέροντας τεχνολογία αιχμής που <strong>μεταμορφώνει τον τρόπο που λειτουργούν οι κλινικές</strong>, με σεβασμό στην ευημερία των ζώων.
                </p>
              </div>
            </div>

            {/* Our Values (Grid) */}
            <section>
              <div style={{ textAlign: 'center', marginBottom: '3rem' }}>
                <h2 style={{ fontSize: '2.25rem', fontWeight: '800', color: 'white' }}>Οι Αξίες μας</h2>
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '1.5rem' }}>
                {values.map((value, idx) => (
                  <div key={idx} style={{ 
                    backgroundColor: 'rgba(255,255,255,0.03)', 
                    padding: '2rem', 
                    borderRadius: '1.25rem', 
                    border: '1px solid rgba(255,255,255,0.05)',
                    transition: 'all 0.3s ease'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-5px)';
                    e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.06)';
                    e.currentTarget.style.borderColor = '#10B981';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.03)';
                    e.currentTarget.style.borderColor = 'rgba(255,255,255,0.05)';
                  }}>
                    <div style={{ color: '#10B981', marginBottom: '1.25rem' }}>
                      <svg width="32" height="32" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        {value.icon}
                      </svg>
                    </div>
                    <h3 style={{ fontSize: '1.3rem', fontWeight: '700', color: 'white', marginBottom: '0.75rem' }}>
                      {value.title}
                    </h3>
                    <p style={{ fontSize: '0.95rem', color: '#9CA3AF', lineHeight: '1.6' }}>
                      {value.desc}
                    </p>
                  </div>
                ))}
              </div>
            </section>

            {/* Our Story (Highlighted Section) */}
            <section style={{ 
              background: 'linear-gradient(135deg, rgba(16,185,129,0.1) 0%, rgba(59,130,246,0.1) 100%)', 
              padding: '3rem', 
              borderRadius: '2rem', 
              border: '1px solid rgba(16,185,129,0.2)',
              position: 'relative',
              overflow: 'hidden'
            }}>
              {/* Decorative quote mark */}
              <div style={{ position: 'absolute', top: '-1rem', left: '1rem', fontSize: '10rem', color: 'rgba(255,255,255,0.05)', fontFamily: 'serif', lineHeight: 1 }}>"</div>
              
              <h2 style={{ fontSize: '2.25rem', fontWeight: '800', color: 'white', marginBottom: '1.5rem', position: 'relative' }}>
                Πώς ξεκινήσαμε
              </h2>
              <p style={{ fontSize: '1.15rem', color: '#E5E7EB', lineHeight: '1.8', marginBottom: '1.5rem', position: 'relative' }}>
                Το <strong>TailClinic</strong> γεννήθηκε το 2025 όταν διαπιστώσαμε από πρώτο χέρι την πίεση που δέχονται οι κτηνιατρικοί επαγγελματίες. Είδαμε εξαιρετικούς γιατρούς να χάνουν πολύτιμο χρόνο σε απαρχαιωμένα συστήματα, τετράδια και τηλέφωνα, αντί να βρίσκονται δίπλα στα ζωάκια.
              </p>
              <p style={{ fontSize: '1.15rem', color: '#E5E7EB', lineHeight: '1.8', position: 'relative' }}>
                Αποφασίσαμε να δημιουργήσουμε την πλατφόρμα που θα θέλαμε να χρησιμοποιούμε οι ίδιοι. Σήμερα, εκατοντάδες κλινικές εμπιστεύονται το TailClinic καθημερινά, κι εμείς συνεχίζουμε με το ίδιο πάθος: να κάνουμε τη ζωή του κτηνιάτρου πιο εύκολη.
              </p>
            </section>

          </div>
        </Container>
      </main>
      
      <Footer />
    </div>
  );
};

export default AboutUsPage;